// Shared phase/time guard for display, aggregation and historical market inversion.
const yes = value => value === true || value === 1 || /^(true|1)$/i.test(String(value));
export function oddsTime(value) {
  if (typeof value === 'number') return value < 1e12 ? value * 1000 : value;
  if (!value) return NaN;
  const s = String(value).replace(' ', 'T');
  return Date.parse(s + (/Z$|[+-]\d\d:?\d\d$/.test(s) ? '' : 'Z'));
}
export function isLiveOffer(odd) {
  return [odd?.is_live,odd?.live,odd?.inplay,odd?.is_inplay].some(yes) ||
    [odd?.type,odd?.phase,odd?.odds_type].some(x=>/live|in.?play|post.?match/i.test(String(x||'')));
}
export function isPrematchOffer(odd) {return odd && !yes(odd.stopped) && !isLiveOffer(odd);}
export function filterPrematchOffers(records, {fixtureId, cutoff, observedAt, historical=false}={}) {
  const end=oddsTime(cutoff), observation=oddsTime(observedAt);
  return (Array.isArray(records)?records:[]).filter(o=>{
    if(!isPrematchOffer(o) || (fixtureId && o.fixture_id && Number(o.fixture_id)!==Number(fixtureId)))return false;
    const times=[o.latest_bookmaker_update,o.updated_at,o.created_at].filter(Boolean).map(oddsTime);
    if(times.some(t=>!Number.isFinite(t)))return false;
    if(Number.isFinite(end) && times.some(t=>t>=end))return false;
    // Unknown timestamps are usable only if actually observed before the cutoff.
    if(historical && !times.length && !(Number.isFinite(observation)&&observation<end))return false;
    return true;
  });
}
